<script setup>
    import { ref, computed, defineEmits } from "vue";
    import http from '../../../api/http'

    const props = defineProps({
        modelValue: { type: String },
        label: {
            type: String,
            default: '평점',
        },
        placeholder: {
            type: String,
            default: "",
        },
        msg: {
            type: String,
            default: '',
        },
        msgColor: {
            type: String,
            default: '#ff0000'
        },
        disabled: {
            type: Boolean,
            default: false
        },
    });
    const emit = defineEmits(["update:modelValue"]);
    const model = computed({
        get() {
            return props.modelValue;
        },
        set(value) {
            emit("update:modelValue", value);
        },
    });

    const inputRef = ref(null)

    const getPhoneMask = () => {
        let res = getMask()
        emit("update:modelValue", res);
    }

    const getMask = ( ) => {
        let str = props.modelValue
        str = str.replace(/[^0-9]/g, '');
        var tmp = '';
        if(str.length < 2){
            return str;
        } else{
            tmp += str.substring(0,1);
            tmp += '.';
            tmp += str.substring(1);
            return tmp;
        }
    }

</script>

<template>
    <div>
        <label>
<!--            <p v-if="label">{{ label }}</p>-->
            <input ref="inputRef" type="text" v-model="model" @input="getPhoneMask" :placeholder="placeholder" :maxlength="4" :disabled="disabled">
        </label>
        <div v-if="msg" :style="{'color': msgColor || $color.labelcolor}"><small>{{ msg }}</small></div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../assets/scss/ui-components/ksa_input";

    label {
        p {
            @include font-size_xs;
            color: $gray_color;
        }
    }
    input {
        &:disabled {
            color: $black_color;
            background: $gray-thin_color;
        }
    }
</style>